/**
 * Mesma máscara de preço usada em addCustomer, addGoal, etc.
 * Retorna "R$ 1.234,56" para exibição no input.
 */
function formatPriceForInput(value) {
    let v = String(value || '');
    v = v.replace(/\D/g, '');
    if (v.length === 0) return '';
    v = v.replace(/(\d{1})(\d{14})$/, '$1.$2');
    v = v.replace(/(\d{1})(\d{11})$/, '$1.$2');
    v = v.replace(/(\d{1})(\d{8})$/, '$1.$2');
    v = v.replace(/(\d{1})(\d{5})$/, '$1.$2');
    v = v.replace(/(\d{1})(\d{1,2})$/, '$1,$2');
    return 'R$ ' + v;
}

export default formatPriceForInput;
